import { Component, OnInit } from '@angular/core';
import { environment as ENV} from 'environments/environment';

@Component({
  selector: 'wl-footer',
  templateUrl: './footer.component.html',
  styles: []
})
export class FooterComponent implements OnInit {

  showOrHide:boolean = true;

  constructor() { }

  ngOnInit() {

      this.showOrHide = false;
    
  }

}
